module.exports = __webpack_public_path__ + "static/media/providers-empty-state-m.c50ec8cd.svg";